import React from "react";
import style from "./index.module.scss";
import { TableProps } from "antd/es/table";
import { Table } from "antd";
import { PaginationConfig } from "antd/lib/table/interface";

interface CommonTableProps<RecordType> extends TableProps<RecordType> {
    height?: string;
    onTableChange?: (pagination: PaginationConfig) => void;
    prompt?: string; //页面为空时提示文案
}

export default function CommonTable<RecordType extends object>({
    height,
    onTableChange,
    prompt = "暂无数据",
    ...restProps
}: CommonTableProps<RecordType>) {
    return (
        <div className={style.root}>
            <Table
                {...restProps}
                onChange={onTableChange}
                locale={{
                    emptyText: (
                        <div className={style.empty} style={{ height: height }}>
                            <img
                                src={require("./img/empty.png")}
                                alt=""
                                className={style.emptyIcon}
                            />
                            <div>{prompt}</div>
                        </div>
                    )
                }}
            />
        </div>
    );
}
